import { useQuery } from "@tanstack/react-query";

import { getClosingMachinesInTimeRange } from "@/api/reporting-api";

import { REPORTING_QUERY_KEYS } from "./query-keys";
import { getReportingGcTime, getReportingStaleTime } from "./utils";
import type { MachineSelectionQueryParams } from "./use-machine-selection";

const isValidMachineSelectionParams = (params: MachineSelectionQueryParams): boolean => {
	return Boolean(params.sites?.length && params.startDate?.isValid && params.endDate?.isValid);
};

export const useClosingMachineSelection = (
	params: MachineSelectionQueryParams,
	options: { enabled?: boolean } = {},
) => {
	const isValidParams = isValidMachineSelectionParams(params);

	const isEnabled = isValidParams && (options.enabled ?? true);

	return useQuery({
		queryKey: REPORTING_QUERY_KEYS.closingMachineSelection(params),
		queryFn: ({ signal }) =>
			getClosingMachinesInTimeRange(
				params.schedules,
				params.sites,
				params.startDate,
				params.endDate,
				params.timeZoneId,
				signal,
			),
		staleTime: getReportingStaleTime([params.startDate, params.endDate]),
		gcTime: getReportingGcTime([params.startDate, params.endDate]),
		enabled: isEnabled,
	});
};
